import { render, staticRenderFns } from "./CenterIndex.vue?vue&type=template&id=835a4084&scoped=true&"
import script from "./CenterIndex.vue?vue&type=script&lang=js&"
export * from "./CenterIndex.vue?vue&type=script&lang=js&"
import style0 from "./CenterIndex.vue?vue&type=style&index=0&id=835a4084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835a4084",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VRow,VSheet,VTextField})
